// @mui material components
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";

// Define the type for the ownerState prop
interface OwnerState {
  variant?: string;
  bgColor?: string;
  color?: string;
  opacity?: number;
  borderRadius?: string;
  shadow?: string;
}


interface CustomTheme {
  palette: {
    gradients: any,
    white: any
  }
  functions: any, 
  borders: any, 
  boxShadows: any
}

export default styled(Box)<{ theme: Theme & CustomTheme; ownerState: OwnerState }>(
  ({ theme, ownerState }) => {
    const { palette, functions, borders, boxShadows } = theme;
    const { variant, bgColor, color, opacity, borderRadius, shadow } = ownerState;
    const { gradients, grey, white } = palette;
    const { linearGradient } = functions;
    const { borderRadius: radius } = borders;

    const greyColors: Record<string, string> = {
      "grey-100": grey[100],
      "grey-200": grey[200],
      "grey-300": grey[300],
      "grey-400": grey[400],
      "grey-500": grey[500],
      "grey-600": grey[600],
      "grey-700": grey[700],
      "grey-800": grey[800],
      "grey-900": grey[900],
    };

    const validGradients = [
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ];

    const validColors = [
      "transparent",
      "white",
      "black",
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "light",
      "dark",
      "text",
      "grey-100",
      "grey-200",
      "grey-300",
      "grey-400",
      "grey-500",
      "grey-600",
      "grey-700",
      "grey-800",
      "grey-900",
    ];

    const validBorderRadius = ["xs", "sm", "md", "lg", "xl", "xxl", "section"];
    const validBoxShadows = ["xs", "sm", "md", "lg", "xl", "xxl", "inset"];

    // background value
    let backgroundValue: string | undefined = bgColor;

    if (variant === "gradient") {
      backgroundValue = validGradients.includes(bgColor || "")
        ? linearGradient(gradients[bgColor!].main, gradients[bgColor!].state)
        : white.main;
    } else if (validColors.includes(bgColor || "")) {
      backgroundValue = palette[bgColor as keyof typeof palette]?.main || greyColors[bgColor!];
    }

    // color value
    let colorValue: string | undefined = color;

    if (validColors.includes(color || "")) {
      colorValue = palette[color as keyof typeof palette]?.main || greyColors[color!];
    }

    // borderRadius value
    let borderRadiusValue: string | undefined = borderRadius;

    if (validBorderRadius.includes(borderRadius || "")) {
      borderRadiusValue = radius[borderRadius as keyof typeof radius];
    }

    // boxShadow value
    let boxShadowValue: string | undefined = shadow;

    if (validBoxShadows.includes(shadow || "")) {
      boxShadowValue = boxShadows[shadow as keyof typeof boxShadows];
    }

    return {
      opacity,
      background: backgroundValue,
      color: colorValue,
      borderRadius: borderRadiusValue,
      boxShadow: boxShadowValue,
    };
  }
);
